import ProgrammedMessageActionContent from './ProgrammedMessageAction.content';
import ProgrammedMessageActionProvider from './ProgrammedMessageAction.provider';

export default function ProgrammedMessageAction() {
  return (
    <ProgrammedMessageActionProvider>
      <ProgrammedMessageActionContent />
    </ProgrammedMessageActionProvider>
  );
}
